import * as React from 'react'
// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'
// icons
import CheckedOriginIcon from '@mui/icons-material/Check'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'
// utils
import { size } from 'polished'

const CheckedIcon = styled(CheckedOriginIcon)`
  margin-left: 8px;
  right: 0;

  ${size('14px')}
`

const CloseIcon = styled((props) => <CloseRoundedIcon {...props} />)`
  && {
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`

const Header = styled('div')`
  align-items: center;
  border-bottom: 1px solid ${colors.blue500};
  color: ${colors.blue500};
  display: flex;
  flex: 1;
  font-size: 14px;
  font-weight: bold;
  height: 32px;
  justify-content: center;
  position: relative;
`

const PermissionWrapper = styled('div')<{ isActive: boolean }>`
  color: ${({ isActive }) => (isActive ? colors.gray850 : colors.gray300)};
  cursor: pointer;
  font-size: 11px;
  padding: 0 8px;
  max-width: 354px;
  margin-top: 8px;

  p {
    margin: 0;
    width: 90%;
  }
`

const PermissionTitle = styled('div')`
  display: flex;
  font-size: 14px;
  align-items: center;
`

const Wrapper = styled('div')`
  max-height: 180px;
  width: 340px;
  padding: 0 12px 12px;

  > div:first-child {
    font-size: 13px;
    justify-content: center;
  }
`

const PermissionsContainer = styled.div`
  overflow: auto;
  height: 136px;
`

export { CheckedIcon, CloseIcon, Header, PermissionWrapper, PermissionTitle, Wrapper, PermissionsContainer }
